/**
 * The moongate web app target. In dev we point at the locally-running app
 * (localhost:8081) so the WaaS embed + CTAs exercise your local build; in
 * production it's the live app.
 */
export const APP_URL =
  process.env.NODE_ENV === "development" ? "http://localhost:8081" : "https://web.moongate.one";

// Contact for demos / sales / developer questions. mailto opens the user's mail client.
export const CONTACT_EMAIL = "degen@moongate.one";
export const CONTACT_URL = `mailto:${CONTACT_EMAIL}`;
